import { render, staticRenderFns } from "./apartment-price-table-header-cell.vue?vue&type=template&id=72a08e4b&scoped=true&"
import script from "./apartment-price-table-header-cell.ts?vue&type=script&lang=ts&"
export * from "./apartment-price-table-header-cell.ts?vue&type=script&lang=ts&"
import style0 from "./apartment-price-table-header-cell.scss?vue&type=style&index=0&id=72a08e4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a08e4b",
  null
  
)

export default component.exports